import { Switch } from "@/components/ui/switch";
import FormInputField from "@/components/lib/from-input-field";
import { Label } from "@/components/ui/label";
import FileUploader from "@/components/common/file-uploader";
import useUploaderConfig from "@/hooks/useUploaderConfig";
import { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import VatSelector from "@/components/common/VatSelector";

function Step3({ form, files, setFiles }) {
  const vat = form.watch("vat");
  const { clientId, restaurantId, directory } = useUploaderConfig("menu");
  const [showVAT, setShowVAT] = useState(false);

  const handleUploadComplete = (fileData) => {
    const fileId = fileData[0]?.file_id;
    if (!fileId) return;
    form.setValue("file_manager_id", fileId);
  };

  useEffect(() => {
    setShowVAT(Boolean(vat && vat !== ""));
  }, [vat]);

  return (
    <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
      <CardHeader>
        <CardTitle>
          {" "}
          {form.watch("type") == "update"
            ? "Update Combo/Set/Offer- Meal"
            : "Add New Combo/Set/Offer- Meal"}{" "}
        </CardTitle>
        <CardDescription className="text-cyellow">
          Item name: {form.watch("name") || "No name"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-8 mt-5">
          {/* VAT Section */}
          <VatSelector form={form} />

          <div className="flex flex-col gap-2.5">
            <FileUploader
              className=""
              files={files}
              multiple={false}
              clientId={clientId}
              restaurantId={restaurantId}
              directory={directory}
              onFilesChange={(updatedFiles) => setFiles(updatedFiles)}
              onUploadComplete={handleUploadComplete}
              replace={true}
              label="Image"
            />
            {form.formState.errors.file_manager_id && (
              <p className="text-red-600 text-xs font-light">
                {form.formState.errors.file_manager_id.message}
              </p>
            )}
          </div>

          <FormInputField
            name="status"
            style="bg-cblack7 h-10"
            placeholder={"Select Status"}
            form={form}
            type="select"
            selectOption={[
              { label: "Select Status", value: "", disabled: true },
              { label: "Active", value: "active" },
              { label: "Archived", value: "archived" },
              { label: "Inactive", value: "inactive" },
            ]}
            label={"Status"}
          />
        </div>
      </CardContent>
    </Card>
  );
}

export default Step3;
